// SPDX-License-Identifier: AGPL-3.0-only

import { createApp } from 'vue';
import App from './App.vue';
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles.css';

createApp(App).mount('#app');
